<template>
  <div class="tg-layout">
    <div class="nav-header" :class="{ 'pre-env': isPreRelease }">
      <div class="logo">
        <img src="~/assets/images/logo.png" alt="" :width="124" />
      </div>

      <el-menu :default-active="activeIndex" class="nav-list" mode="horizontal" @select="clickHref">
        <template v-for="top in topMenus">
          <el-submenu v-if="top.childs" popper-class="nav-list-submenu" :key="top.data.url" :index="top.data.url">
            <span slot="title">{{ top.name }}</span>
            <el-menu-item v-for="child in top.childs" :key="child.data.url" :index="child.data.url">
              {{ child.name }}
            </el-menu-item>
          </el-submenu>

          <el-menu-item v-else :key="`item-${top.data.url}`" :index="top.data.url">
            <div>
              {{ top.name }}
            </div>
          </el-menu-item>
        </template>
      </el-menu>

      <div class="nav-btns">
        <el-tooltip v-if="accessAuth.aiVideoGen" effect="dark" content="AI视频生成" placement="bottom">
          <em class="radar" @click="openAIVideoGen">
            <svg viewBox="0 0 1024 1024" width="26" height="26" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <path
                fill="#333333"
                d="M512.227556 98.531556c29.809778 0 59.164444 7.623111 85.219555 22.186666l218.680889 121.742222a175.104 175.104 0 0 1 89.884444 153.031112v233.187555l-0.398222 11.719111a175.104 175.104 0 0 1-89.486222 141.141334L597.333333 903.395556l-9.955555 5.176888a175.160889 175.160889 0 0 1-150.471111 0l-9.955556-5.233777-218.680889-121.742223a175.217778 175.217778 0 0 1-89.486222-141.312l-0.398222-11.719111V395.434667a175.047111 175.047111 0 0 1 89.884444-152.974223L426.951111 120.604444l11.377778-5.688888a175.217778 175.217778 0 0 1 61.155555-15.928889l12.743112-0.455111z m0 82.887111c-15.701333 0-31.175111 3.982222-44.885334 11.662222l-218.680889 121.742222-4.209777 2.503111 94.435555 54.272a41.528889 41.528889 0 0 1 15.928889 19.057778l1.991111 6.030222a41.528889 41.528889 0 0 1-59.335111 46.762667l-95.857778-55.182222-0.284444 7.168v233.073777a92.16 92.16 0 0 0 47.331555 80.554667l218.680889 121.742222 7.338667 3.584 1.592889 0.568889-1.024-73.386666a41.528889 41.528889 0 0 1 1.251555-10.752l1.706667-5.12a41.528889 41.528889 0 0 1 80.042667 14.791111l0.910222 69.176889 216.576-120.490667c11.491556-6.428444 21.447111-15.189333 29.240889-25.713778l5.461333-8.192c8.305778-14.222222 12.686222-30.321778 12.686222-46.762667V395.434667c0-5.973333-0.625778-11.946667-1.877333-18.033778l-1.820444-6.656 0.853333 3.185778-92.728889 55.751111a41.528889 41.528889 0 0 1-9.955556 4.380444l-5.290666 1.137778a41.528889 41.528889 0 0 1-27.534222-76.572444l81.578666-48.981334-209.237333-116.565333a92.216889 92.216889 0 0 0-35.498667-11.150222l-9.386666-0.512z m0 179.2a23.096889 23.096889 0 0 1 21.788444 15.644444L562.858667 460.8a14.108444 14.108444 0 0 0 8.817777 8.817778l84.536889 28.842666a23.096889 23.096889 0 0 1 0 43.633778l-84.536889 28.899556a14.051556 14.051556 0 0 0-8.817777 8.760889l-28.842667 84.536889a23.096889 23.096889 0 0 1-43.690667 0l-28.785777-84.536889a14.108444 14.108444 0 0 0-8.817778-8.760889l-84.593778-28.899556a23.096889 23.096889 0 0 1 0-43.633778l84.593778-28.842666a14.222222 14.222222 0 0 0 8.817778-8.817778l28.785777-84.536889a23.096889 23.096889 0 0 1 21.845334-15.644444z"
              ></path>
            </svg>
          </em>
        </el-tooltip>

        <el-tooltip v-if="accessAuth.intelligence" effect="dark" content="创意情报" placement="bottom">
          <em class="radar" @click="openCreativeIntelligence">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
              <path
                d="M787.2 350.592l86.08-22.848a388.736 388.736 0 0 0-218.24-260.096l-37.44 80.64C519.936 75.904 381.952 30.016 289.856 107.328a373.632 373.632 0 0 0 136 651.2v134.4h-146.56a32 32 0 0 0 0 64h430.528a32 32 0 0 0 0-64H489.856v-122.432a373.632 373.632 0 0 0 280.256-89.6c92.224-77.504 70.784-221.888 17.088-330.304zM589.888 208.256l-102.4 221.632 235.712-62.4c99.776 186.88 32 334.784-140.224 276.48A475.776 475.776 0 0 1 293.76 298.816c-28.48-186.944 135.936-216.768 296.128-90.56zM230.4 304.256a533.824 533.824 0 0 0 334.528 400.896A308.352 308.352 0 0 1 230.4 304.256z"
              ></path>
            </svg>
          </em>
        </el-tooltip>

        <el-tooltip effect="dark" content="下载中心" placement="bottom">
          <em class="download" :class="downloadBadgeActive && 'badge'" @click="enterDownloadCenter">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
              <path
                d="M813.30688 371.53792c-27.02336-138.51136-148.64384-243.23584-297.28256-243.23584-148.64384 0-270.26432 104.72448-297.28768 243.23584C117.38112 398.56128 43.0592 493.15328 43.0592 601.25696c0 131.75296 104.72448 236.48256 236.48256 236.48256h33.78176v-67.56352h-33.78176c-94.592 0-168.91392-74.32192-168.91392-168.9088 0-94.592 74.32192-168.91392 168.91392-168.91392 0-131.75296 104.72448-236.48256 236.48256-236.48256s236.48256 104.7296 236.48256 236.48256c94.592 0 168.9088 74.32192 168.9088 168.91392s-74.32192 168.9088-168.9088 168.9088h-33.792v67.56352h33.792c131.74784 0 236.48256-104.71936 236.48256-236.48256-0.01024-108.10368-74.33216-202.69568-175.68256-229.71904zM492.37504 928.81408c13.51168 10.1376 27.01824 13.51168 40.53504 6.7584 3.37408 0 6.7584-3.37408 10.13248-6.7584l101.34528-97.9712c13.51168-13.51168 13.51168-33.792 0-47.28832-13.50656-13.5168-37.16096-13.5168-50.6624 0l-40.54528 37.15584V533.5552c0-20.27008-16.89088-33.78176-33.792-33.78176-20.27008 0-33.78176 16.89088-33.78176 33.78176v287.1552l-40.54016-37.15584c-13.51168-13.5168-37.16096-13.5168-50.67264 0-13.51168 13.50144-13.51168 33.78176 0 47.28832l97.98144 97.9712z"
                fill="#333333"
              ></path>
            </svg>
          </em>
        </el-tooltip>

        <el-tooltip v-if="accessAuth.videoCut" effect="dark" content="视频混剪" placement="bottom">
          <em class="video-cut" @click="openVideoCutPage">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
              <path
                fill="#333333"
                d="M603.363556 116.337778a227.498667 227.498667 0 0 1 227.441777 223.232c5.802667-3.982222 11.264-7.509333 16.497778-10.581334 19.399111-11.264 48.412444-24.064 80.213333-11.719111 16.440889 6.371556 30.037333 17.180444 40.675556 29.980445l4.323556 5.688889c16.099556 22.186667 20.878222 49.948444 23.04 76.344889 2.275556 27.420444 2.275556 63.032889 2.275555 106.666666 0 43.633778 0 79.246222-2.275555 106.666667-2.161778 26.396444-6.940444 54.215111-22.983112 76.401778l-0.056888-0.056889c-11.093333 15.36-26.168889 28.16-44.430223 35.612444l-0.568889 0.227556-5.973333 1.991111c-29.411556 8.704-56.035556-3.242667-74.24-13.824a277.617778 277.617778 0 0 1-16.497778-10.581333 227.555556 227.555556 0 0 1-227.441777 223.402666H259.584a227.555556 227.555556 0 0 1-227.555556-227.555555V536.064a45.511111 45.511111 0 1 1 91.022223 0V728.177778a136.533333 136.533333 0 0 0 136.533333 136.533333h343.779556a136.533333 136.533333 0 0 0 136.533333-136.533333V343.893333a136.533333 136.533333 0 0 0-136.533333-136.533333H370.801778a45.511111 45.511111 0 0 1 0-91.022222h232.561778z m289.848888 291.271111c-6.769778 3.982222-14.677333 9.443556-24.519111 16.782222l-36.295111 27.761778-1.479111 1.024v165.489778l1.536 1.080889c29.070222 22.641778 47.217778 36.693333 60.757333 44.600888 1.820444 1.024 3.413333 1.706667 4.664889 2.275556l0.910223-0.910222V665.6l0.910222-1.706667c1.365333-3.128889 3.697778-10.979556 5.12-28.728889 1.877333-22.755556 1.991111-53.930667 1.991111-99.214222s-0.113778-76.401778-1.991111-99.157333c-1.934222-23.779556-5.461333-29.809778-5.973334-30.492445V406.186667c-0.227556-0.398222-0.682667-0.682667-0.967111-1.024-1.251556 0.625778-2.844444 1.308444-4.664889 2.389333z"
              ></path>
              <path
                fill="#333333"
                d="M384.568889 392.704c19.399111-2.787556 36.977778 2.503111 50.517333 7.850667 15.530667 6.144 33.905778 15.928889 53.930667 26.567111l29.354667 15.815111c9.102222 5.12 17.408 10.012444 24.405333 14.791111 11.832889 8.078222 27.136 20.309333 35.384889 39.424l3.128889 8.647111v0.170667l2.275555 11.207111c1.365333 9.557333 0.796444 19.342222-1.251555 28.842667-0.113778 0.967111-0.398222 1.934222-0.568889 2.844444l-0.398222 2.104889-1.536 4.437333-0.398223 0.910222c-7.793778 21.048889-24.120889 34.360889-36.636444 42.894223-14.051556 9.557333-33.109333 19.512889-53.816889 30.492444v0.056889c-19.911111 10.638222-38.286222 20.48-53.816889 26.624-15.473778 6.144-36.238222 12.117333-58.993778 6.087111l-0.455111-0.056889a89.315556 89.315556 0 0 1-37.717333-21.048889h0.056889c-17.806222-16.839111-22.812444-38.513778-24.803556-54.840889-1.991111-16.213333-1.877333-36.579556-1.877333-58.026666 0-21.504-0.113778-41.870222 1.877333-58.026667 1.991111-16.440889 6.997333-38.115556 24.860445-54.954667l8.533333-7.111111c8.874667-6.485333 18.887111-11.150222 29.468444-13.937777l8.476445-1.706667z m18.602667 93.184c-0.739556 9.216-0.853333 22.186667-0.853334 42.552889 0 20.309333 0.113778 33.28 0.853334 42.496 9.557333-3.982222 22.471111-10.581333 43.178666-21.560889l27.818667-14.904889c3.925333-2.218667 7.338667-4.209778 10.353778-6.030222a351.857778 351.857778 0 0 0-10.410667-5.916445l-27.704889-14.961777a588.686222 588.686222 0 0 0-43.235555-21.674667z"
              ></path>
              <path
                fill="#333333"
                d="M171.008 113.777778a45.511111 45.511111 0 0 1 45.511111 45.511111v163.214222l13.312-13.312a45.511111 45.511111 0 1 1 64.284445 64.284445L203.207111 464.554667a45.511111 45.511111 0 0 1-5.973333 4.892444l-2.616889 1.592889a44.942222 44.942222 0 0 1-3.811556 2.104889c-1.024 0.512-2.048 1.024-3.072 1.422222a45.624889 45.624889 0 0 1-14.506666 3.185778h-0.113778a45.226667 45.226667 0 0 1-14.904889-1.877333l-2.616889-0.739556c-0.625778-0.284444-1.308444-0.398222-1.991111-0.682667l-2.56-1.365333-2.616889-1.251556a45.340444 45.340444 0 0 1-7.224889-5.12l-2.389333-2.161777-91.022222-91.022223-3.072-3.470222a45.511111 45.511111 0 0 1 64.056889-64.056889l3.413333 3.185778 13.312 13.312v-163.271111a45.511111 45.511111 0 0 1 45.511111-45.454222z"
              ></path>
            </svg>
          </em>
        </el-tooltip>

        <!-- 视频异步任务 -->
        <el-popover placement="top-start" title="视频处理任务" width="500" trigger="hover">
          <Table :columns="columns" :data="videoProcess" :max-height="500" />
          <!-- <el-button slot="reference">任务：({{ comProcess }}/{{ process }})</el-button> -->
          <em style="display: block; display: flex; align-items: center" slot="reference">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
              <path d="M0 0h1024v1024H0z" fill="#999" opacity=".01"></path>
              <path
                d="M273.066667 68.266667a34.133333 34.133333 0 0 0-34.133334 34.133333v68.266667H170.666667a102.4 102.4 0 0 0-102.4 102.4v512a170.666667 170.666667 0 0 0 170.666666 170.666666h546.133334a170.666667 170.666667 0 0 0 170.666666-170.666666V273.066667a102.4 102.4 0 0 0-102.4-102.4h-68.266666V102.4a34.133333 34.133333 0 1 0-68.266667 0v68.266667H307.2V102.4a34.133333 34.133333 0 0 0-34.133333-34.133333z m34.133333 170.666666h409.6v34.133334a34.133333 34.133333 0 1 0 68.266667 0V238.933333h68.266666a34.133333 34.133333 0 0 1 34.133334 34.133334v102.4H136.533333V273.066667a34.133333 34.133333 0 0 1 34.133334-34.133334h68.266666v34.133334a34.133333 34.133333 0 0 0 68.266667 0V238.933333z m580.266667 204.8v341.333334a102.4 102.4 0 0 1-102.4 102.4H238.933333a102.4 102.4 0 0 1-102.4-102.4V443.733333h750.933334z m-180.667734 78.267734a34.133333 34.133333 0 0 1 0 48.264533l-204.8 204.8a34.133333 34.133333 0 0 1-48.264533 0l-136.533333-136.533333a34.133333 34.133333 0 1 1 48.264533-48.264534L477.866667 702.6688l180.667733-180.667733a34.133333 34.133333 0 0 1 48.264533 0z"
                fill="#333333"
              ></path>
            </svg>
            <span>&ensp;任务：({{ comProcess }}/{{ process }})</span>
          </em>
        </el-popover>

        <div class="profile">
          <!-- 个人中心 -->
          <profile :account="admin" :account-name="title" />
        </div>
      </div>
    </div>
    <!-- nav -->
    <nav-tags :value="$route" :list="tagNavList" @on-close="handleCloseTag" />
    <!-- 路由组件 -->
    <router-view />
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { mapMutations } from 'vuex'
import { HOST_API } from '@/api/config'
import { isArray, timeout } from '@/common/js/utils'
import { datetimeToSec } from '@/common/js/filters'
import { routeEqual, getTagKey } from '@/common/js/tools'
import { retryVideoProcessById, stopVideoProcessById } from '@/api/material.model'
import Profile from '@/components/header/profile.vue'
import NavTags from '@/components/layout/nav-tags.vue'
import navMixin from '@/components/layout/nav-mixin'

let TIMER
const toTaskStatus = (cell) => {
  if (cell === 0) return '未开始'
  else if (cell === 1) return '进行中'
  else if (cell === 2) return '已完成'
  else if (cell === 3) return '失败'
  else if (cell === 4) return '已终止'
  else return '未知'
}
export default {
  name: 'Front',
  mixins: [navMixin],
  components: {
    NavTags,
    Profile
  },
  data() {
    return {
      activeIndex: '/adplan/toutiaonew',
      columns: [
        { title: '任务名称', key: 'taskName', width: 180 },
        {
          title: '任务进度',
          key: 'taskCnt',
          width: 90,
          render: (h, params) => {
            return h('span', `${(params.row.taskFailedCnt || 0) + (params.row.taskSuccessCnt || 0)}/${params.row.taskCnt}`)
          }
        },
        {
          title: '任务状态',
          key: 'taskStatus',
          width: 90,
          render: (h, params) => {
            if (params.row.taskFailedCnt) {
              return h('span', `${toTaskStatus(params.row.taskStatus)}，失败${params.row.taskFailedCnt}条`)
            } else return h('span', toTaskStatus(params.row.taskStatus))
          }
        },
        {
          title: '提交时间',
          key: 'addTime',
          width: 160,
          render: (h, params) => {
            return h('span', datetimeToSec(params.row.addTime))
          }
        }
      ],
      arrawDown: 'caret-down',
      locationUrl: `${window.location.protocol}//${window.location.hostname}`
    }
  },
  computed: {
    accessAuth() {
      const codes = this.$store.state.accessAuth
      return {
        videoCut: codes.includes('M21214'),
        intelligence: codes.includes('M21273'),
        aiVideoGen: codes.includes('M21281')
      }
    },
    isPreRelease() {
      return this.$store.getters.isPreRelease
    },
    downloadBadgeActive() {
      return this.$store.state.downloadBadgeActive
    },
    admin() {
      return Cookies.get('ch_user_name')
    },
    title() {
      return Cookies.get('ch_user_name')
    },
    account() {
      return Cookies.get('ch_user_name')
    },
    current() {
      const { params, matched } = this.$route // path,
      const keys = matched
        .filter((ret) => ret.path)
        .map((ret) => {
          if (params) {
            const { id } = params
            return ret.path.replace(/:id/g, id)
          } else return ret.path
        })
      return keys
    },
    tagNavList() {
      return this.$store.state.tagNavList
    },
    topMenus() {
      const menus = this.$store.state.menuAuth
      this.setDefaultIndex(menus)
      return menus
    },
    activeBtnVisiable() {
      return this.$store.state.game
    },
    process() {
      return this.$store.state.process
    },
    comProcess() {
      return this.$store.getters.comprocess
    },
    videoProcess() {
      return this.$store.state.videoProcess
    }
  },
  methods: {
    ...mapMutations(['setTagNavList', 'addTag']),
    openVideoCutPage() {
      window.open('/creatives/video-clip-mix', '_blank')
    },
    enterDownloadCenter() {
      this.$router.push({ name: 'downloadCenter' })
    },

    openCreativeIntelligence() {
      window.open('/creative-intelligence/trends', '_blank')
    },

    openAIVideoGen() {
      window.open('/ai-video-generation', '_blank')
    },
    /**
     * @description: 因为cas设置的url与本项目的路由path不一致，导致直接设置默认高亮的路由不生效
     * @description: 本方法找到cas设置的路由，作为当前应当高亮的默认菜单
     * @param {*} menus
     */
    setDefaultIndex(menus) {
      const path = this.$route.path
      let url = ''

      try {
        menus.forEach((menu) => {
          if (menu.childs) {
            menu.childs.forEach((c) => {
              if (path.includes(c.data.url)) {
                url = c.data.url
                throw new Error('')
              }
            })
          } else {
            if (path.includes(menu.data.url)) {
              url = menu.data.url
              throw new Error('')
            }
          }
        })
      } catch (e) {}

      this.activeIndex = url
    },
    clickHref(index) {
      if (this.current.indexOf(index) > -1) return
      this.$router.push({ path: index })
    },
    logout() {
      this.$store.commit('setToken', '')
      window.location.href = `${HOST_API}/auth/logout?url=${this.locationUrl}`
    },

    handleCloseTag(route) {
      const currentKey = getTagKey(this.$route)
      const isCurrent = currentKey === route.key

      if (isCurrent) {
        const list = this.tagNavList
        const index = list.findIndex((item) => item.key === route.key)
        let nextRoute = null

        if (list.length > 1 && index > -1) {
          if (index === list.length - 1) nextRoute = list[list.length - 2]
          else nextRoute = list[index + 1]
        }

        if (nextRoute) {
          this.turnToPage(nextRoute)
        }
      }
      this.$store.dispatch('closeTag', { route })
    },
    addNavTag(route) {
      this.$store.dispatch('addTag', route)
    },
    retryTask(row) {
      const { id } = row
      this.$set(row, 'retring', true)
      retryVideoProcessById({ imageTaskId: id })
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.$set(row, 'retring', false)
            data && this.$bus.$emit('LoopDispatch')
          }
        })
        .catch(() => {
          this.$set(row, 'retring', false)
        })
    },
    stopTask(row) {
      const { id } = row
      this.$set(row, 'stoping', true)
      stopVideoProcessById({ imageTaskId: id })
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.$set(row, 'stoping', false)
            data && this.$bus.$emit('LoopDispatch')
          }
        })
        .catch(() => {
          this.$set(row, 'stoping', false)
        })
    }
  },
  mounted() {
    this.$nextTick(() => {
      const account = Cookies.get('ch_op_name')
      const name = Cookies.get('ch_user_name')
      this.$appendWaterMark(this.$el, `${account} ${decodeURIComponent(name)}`)
      this.addNavTag(this.$route)
    })
  },

  watch: {
    $route(to) {
      this.addNavTag(to)
    }
  },
  created() {
    const EVENT_LOOP = () => {
      this.$store.dispatch('getVideoProcessTask').then((data) => {
        if (data && data.page_info && data.page_info.total_number) {
          if (this.comProcess !== data.page_info.total_number) {
            TIMER = setTimeout(() => {
              EVENT_LOOP()
            }, 10000)
          } else if (TIMER) this.$bus.$emit('ClearLoop')
        } else if (data && TIMER) this.$bus.$emit('ClearLoop')
      })
    }
    // 监听任务
    this.$bus.$on('LoopDispatch', () => {
      if (TIMER) clearTimeout(TIMER)
      EVENT_LOOP()
    })
    // 结束监听
    this.$bus.$on('ClearLoop', () => {
      clearTimeout(TIMER)
    })
    this.$bus.$emit('LoopDispatch')
  },
  beforeDestroy() {
    this.$bus.$off('LoopDispatch')
    this.$bus.$off('ClearLoop')
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';
.nav-header {
  height: 64px;
  line-height: 64px;
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;

  &.pre-env {
    background-color: #ffc75f;
    ::v-deep .nav-list {
      background-color: #ffc75f;
    }
  }

  .logo {
    display: flex;
    align-items: center;
    min-width: 172px;
    justify-content: space-around;
  }

  // 导航栏
  ::v-deep .nav-list {
    border-bottom: none;
    flex: 1;

    .el-submenu {
      &.is-active {
        .el-submenu__title {
          border-bottom-width: 3px;
        }
      }
    }

    .el-menu-item,
    .el-submenu__title {
      height: 64px;
      line-height: 64px;
      color: $text-color;
      .el-submenu__icon-arrow {
        display: none;
      }
    }
  }

  .nav-btns {
    display: flex;
    align-items: center;
    > em {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .video-cut {
      margin-right: 20px;
    }
    .download,
    .radar {
      margin-right: 20px;
      font-size: 24px;
      cursor: pointer;
      position: relative;
      &.badge {
        &::after {
          content: '';
          position: absolute;
          right: -5px;
          top: 8px;
          z-index: 1;
          width: 9px;
          height: 9px;
          border-radius: 100px;
          background: red;
        }
      }
    }
    .profile {
      display: flex;
      margin-left: 20px;
    }
  }
}
.el-menu--horizontal.nav-list-submenu .el-menu {
  .el-menu-item {
    height: 40px;
    line-height: 40px;
    color: $text-color;
    &:hover {
      color: $primary-color;
    }
    &.is-active {
      color: $primary-color !important;
    }
  }
}
</style>
